import Pause from './Pause'

export default Pause
// eslint-disable-next-line import/export
export * from './Pause'
